import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import SEO from "../components/SEO";
import { Shield } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password, remember);
      nav("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen grid place-items-center bg-stone-50 px-4">
      <SEO title="Staff Login" description="VidaVital admin staff login." path="/admin/login" noindex />
      <div className="vv-card p-10 w-full max-w-md">
        <div className="flex items-center gap-2 text-[color:var(--vv-teal)]"><Shield size={20} /><span className="text-xs uppercase tracking-widest">Staff Login</span></div>
        <h1 className="font-display text-3xl mt-2">VidaVital Admin</h1>
        <p className="text-sm text-stone-500 mt-2">Sign in to manage therapies, approvals, and consultation requests.</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <label className="text-sm block">Email
            <input required data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full border border-stone-200 rounded-lg px-3 py-2 bg-white" />
          </label>
          <label className="text-sm block">Password
            <input required data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full border border-stone-200 rounded-lg px-3 py-2 bg-white" />
          </label>
          <label className="text-xs flex items-center gap-2 text-stone-600 select-none">
            <input
              type="checkbox"
              data-testid="admin-remember"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
              className="accent-[color:var(--vv-gold-deep)]"
            />
            Remember me for 30 days on this device
          </label>
          <button data-testid="admin-submit" disabled={busy} className="vv-btn-primary w-full justify-center">{busy ? "Signing in…" : "Sign in"}</button>
        </form>
        <Link to="/" className="block mt-6 text-xs text-stone-500 hover:text-stone-800 text-center">← Back to site</Link>
      </div>
    </div>
  );
}
